import { render, staticRenderFns } from "./NodeContentEditable.vue?vue&type=template&id=10cffb2c&"
import script from "./NodeContentEditable.vue?vue&type=script&lang=ts&"
export * from "./NodeContentEditable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports